<template>
<div class="main">
  <div class="tac fs3 countbox">
    <h2 class="pbw">今日概览 <time class="fs2 countbox__time">{{today}}</time> </h2>
    <div class="van-row mtn">
      <div class="van-col van-col--8">
          <div>{{overview.clubPracticeCard}}</div> 
          <div class="mtn fs2">练球卡</div>
      </div>
      <div class="van-col van-col--8">
          <div>{{overview.clubPtCourse}}</div> 
          <div class="mtn fs2">教练课时</div>
      </div>
      <div class="van-col van-col--8">
          <div>{{overview.application}}</div> 
          <div class="mtn fs2">比赛报名</div>
      </div> 
    </div>
  </div>
  <div class="select-box fs2 bcw clear">
    <c-select
        :text="selectTypeName"
        :actions="orderTypes"
        @select="selectType"
        class="type-select right"
      ></c-select>
  </div>

  <!-- 列表 -->
  <div class="clear scancode__item fs2" v-for="(item,index) in list" :key="index">
    <div class="scancode__item1">
      <div @click="goTo(item.user.id)"><avatar-box class="left mrm" :avatar="item.user.largeAvatar" :auth="item.user.is_vip"></avatar-box></div>      
      <div class="clear scancode__info">
        <div class="c4 fs2">{{item.user.nickname}}</div>
        <div class="scancode__auth mtn fs1 c9">{{createdtime(item.createdTime)}}</div>
      </div>
    </div>
    <div class="scancode__item2 green">
        {{showType(item.targetType)}}
    </div>
    <div class="scancode__item3">
      <span class="blue" v-if="item.type=='order'">订单</span>
      <span class="red" v-else-if="item.type=='coupon'">优惠券</span>
    </div>
  </div>
  
  <div v-if="list.length==0" class="tac mtw c9 fs2">~ 暂无记录 ~</div>
  <div v-if="list.length!=0 && listTotal>pageSize" class="tac c9 bcw ptm pbw" @click="loadMore()" v-show="loadShow">{{loadTxt}}</div>
  <!-- //列表 -->
  <div class="clear bcw buybar">
    <div class="buybar__content clear">
      <van-button type="primary" size="large" class="fs3" @click="scanCode()"><i class="my-model__icon iconfont scan mrm">&#xe607;</i>扫码核销</van-button>
    </div>
  </div>
</div>
</template>
<script>
import Vue from "vue";
import { Row, Col,Toast } from "vant";
import AvatarBox from "@/components/AvatarBox";
import CSelect from "@/components/Select";
import wx from "weixin-js-sdk";
import weChat from "@/assets/scripts/wechat";
import moment from "moment";
moment.locale("zh-cn");
Vue.use(Row).use(Col).use(Toast);

export default {
  name: "CourseItem",
  components: {
    AvatarBox,
    CSelect
  },
  data() {
    return {
      list: [], // 核销列表
      overview:{},//概览
      orderTypes: [
        {
          name: "全部记录",
          type: null
        },
        {
          name: "万能优惠券",
          type: 'all'
        }
      ],
      currentType: {},//当前筛选类型
      today:moment(new Date()).format('YYYY-MM-DD'),
      page: 1,
      pageSize: 15,
      loadShow: true,
      loadTxt: "加载更多",
      listTotal:'', //列表总数
    };
  },
  created() {
    this.currentType = this.orderTypes[0];
    //核销列表
    this.getList();

    //今日概览
    this.$http.post("club_write_off/overview",{
      day: this.today
    }).then(res => {
      if (!res.data.code) {
        this.overview = res.data.value
      } else {
        Toast.fail(res.data.message);
      }
    });

    //类型列表
    this.$http.post("my_order/orderTypes").then(res => {
      // console.log(res);
      if (!res.data.code) {
        this.orderTypes = this.orderTypes.concat(res.data.value)
      } else {
        Toast.fail(res.data.message);
      }
    });
  },
  methods: {
    goTo: function(id) {
      location.href =`${location.origin}` + "/training/#/userHome?userId=" + id;
    },
    selectType(item) {
      //select筛选
      // console.log(item)
      this.currentType = item;
      this.getList(item.type);
    },
    loadMore() {
      //加载更多
      this.loadTxt = "正在加载";
      this.page++;
      this.getList(this.currentType.type,'more');
    },
    getList(targettype,more) {
      // console.log(this.page);
      //获取列表
      this.$http.post("club_write_off/getList", {
        targetType:targettype,
        page: this.page,
        limit: this.pageSize
      }).then(res => {
        // console.log(res);
        if (!res.data.code) {
          let re = res.data.value;
          this.listTotal = re.total
          if(more=='more'){
            //是 加载更多
            this.list = this.list.concat(re.list);
            this.loadTxt = "加载更多";
            if (re.list.length < this.pageSize) {
              this.loadShow = false;
            } 
          }else{
            //否 加载更多
            this.list = re.list
          }                   
        } else {
          Toast.fail(res.data.message);
          this.loadTxt = "加载更多";
        }
      })
    },
    scanCode() {
      weChat.wxConfig().then(() => {
        // 扫一扫
        wx.scanQRCode({
          needResult: 0, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
          success: function(res) {
            //console.log(res.resultStr); // 当needResult 为 1 时，扫码返回的结果
          }
        });
      });
    },
    createdtime: function (time) {
      //核销时间
      return moment(time*1000).format('YYYY-MM-DD HH:mm')
    },
    showType: function(sta){
      //类型
      switch (sta) {
        case 'course': 
          return '课程';
          break;
        case 'vip':
          return '会员';
          break;
        case 'product':
          return '活动';
          break;
        case 'clubGroupCourse':
          return '俱乐部团课';
          break;
        case 'clubMonthCard':
          return '俱乐部月卡';
          break;
        case 'clubPracticeCard':
          return '俱乐部练球卡';
          break;
        case 'clubPtCourse':
          return '俱乐部私教课';
          break;
        case 'gradingLevelVerify':
          return '训练营等级认证';
          break;
        case 'gradingLevelAimUnlock':
          return '训练营目标解锁';
          break;
        case 'application':
          return '应用';
          break;
        case 'all':
          return '万能优惠券';
          break;
        default:  // defalle
          return '特殊类型';
      }
    }
  },
  computed: {
    selectTypeName() {
      return this.currentType.name;
    }    
  }
};
</script>

<style lang="less">
// 今日概览
.countbox {
  position: relative;
  padding: 0.2rem 0.15rem 0.3rem;
  background: #67ca82;
  color: #fff;
  &__time {
    position: absolute;
    right: 0.15rem;
    top: 0.2rem;
  }
  & .van-col {
    border-right: 1px solid #fff;
  }
  & .van-col:last-child {
    border: 0;
  }
}
// 下拉框
.select-box {
  padding: 0.15rem;
  border-bottom: 0.05rem solid #f1f1f1;
}
// 已购买者弹出层
.scancode {
  &__item {
    background: #fff;
    display: flex;
    justify-content: space-around;
    border-bottom: 0.01rem #f6f6f6 solid;
    padding: 0.15rem .05rem .15rem .15rem;
  }
  &__item > div {
    flex: 1;
  }
  &__item > &__item1 {
    flex: 0 0 55%;
  }
  &__item > &__item2 {
    flex: 0 0 30%;
    text-align: center;
    line-height: 0.4rem;
    white-space: nowrap;
  }
  &__item > &__item3 {
    flex: 0 0 15%;
    text-align: center;
    line-height: 0.4rem;
    white-space: nowrap;
  }
  &__info {
    overflow: hidden;
  }
}
@supports (bottom: constant(safe-area-inset-bottom)) or (bottom: env(safe-area-inset-bottom)) {
  .buybar {
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
  .main{ 
    padding-bottom: calc(60px+constant(safe-area-inset-bottom));
    padding-bottom: calc(60px+env(safe-area-inset-bottom));
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ScanCode.vue